import { ReactNode, useState } from 'react';
import { Collapse } from 'react-bootstrap';
import './ElementDetailCollapse.scss';

interface ElementDetailCollapseProps {
    title: string;
    children?: ReactNode;
    isOpenDefault?: boolean;
    headerAction?: ReactNode;
    className?: string;
    ocult?: boolean;
}

export const ElementDetailCollapse = (props: ElementDetailCollapseProps) => {
    const [showContent, setShowContent] = useState(!!props.isOpenDefault);
    if (props.ocult) return null;

    return (
        <div className={`ElementDetailCollapse ${props.className || ''}`}>
            <div className='ElementDetailCollapse-header' onClick={() => setShowContent(prev => !prev)}>
                <span className='ElementDetailCollapse-title'>{props.title}</span>
                <div className='ElementDetailCollapse-actions'>
                    { props.headerAction ? <div onClick={(evt) => evt.stopPropagation()}>{props.headerAction}</div> : null }
                    <button type='button' className='ElementDetailCollapse-toggle'>
                        <i className={`fa-solid fa-chevron-down ${showContent ? 'ElementDetailCollapse-toggle-open' : ''}`} />
                    </button>
                </div>
            </div>
            <Collapse in={showContent}>
                <div>
                    <div className='ElementDetailCollapse-body'>
                        { props.children }
                    </div>
                </div>
            </Collapse>
        </div>
    )
}
